import { render } from "./payroll-detail.vue?vue&type=template&id=54762b65&scoped=true&ts=true"
import script from "./payroll-detail.vue?vue&type=script&lang=ts"
export * from "./payroll-detail.vue?vue&type=script&lang=ts"

import "./payroll-detail.vue?vue&type=style&index=0&id=54762b65&lang=stylus&scoped=true"

import exportComponent from "C:\\work\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54762b65"]])

export default __exports__